import moment from "moment";

export function getDatesInRange(startDateInput, endDateInput) {
  const startDate = moment(startDateInput);
  const endDate = moment(endDateInput);

  const daysCount = endDate.diff(startDate, 'days') + 1;

  const dates = [];
  for (let i = 0; i < daysCount; i++) {
    const date = moment(startDate).add(i, 'days').format('YYYY-MM-DD');
    dates.push(date);
  }

  return dates;
}